import { Link } from "react-router-dom";
import React, { useState } from "react";
import { useFormik, FieldArray, FormikProvider } from "formik";
import * as Yup from "yup";
import "./ApplyAcademy.css";
import Model from "../../../utils/model";
import ApiService from "../../../classes/ApiService";
import { toast } from "react-toastify";
import ToastContent from "../../ToastContent";

const ApplyAcademy = () => {
  const api = new ApiService();
  const [showModal, setShowModal] = useState(false);
  // const isDisabled = true;
  //const [modalContent, setModalContent] = useState();
  const modalContent = {
    icon: "/img/check_green.svg", // Replace with your desired icon
    header: "We've Received Your Request",
    body: "Thank you for applying to be featured on the Rentid Podcast! Our team will review your submission, and we’ll reach out if you’re a fit. We’re excited to learn more about you!.",
    button: 'Got it',
    handleSuccess: () => {
      //console.log("Modal button clicked!");
      window.location.href = '/rentacademy';
    }

  };

  function formatSocialMedia(data) {
    return data.map(item => `${item.socialMedia}: ${item.followers} followers`).join('\n');
}



  const formik = useFormik({
    initialValues: {
      first_name: "",
      email_address: "",
      phone_number: "",
      companyName: "",
      socialMediaLinks: [{ socialMedia: "", followers: "" }],
      followers: "",
      experience: "",
      topic: "",
      reason: "",
    },
    validationSchema: Yup.object({
      full_name: Yup.string().required("Full name is required"),
      email_address: Yup.string()
        .email("Invalid email address")
        .required("Email is required"),
      phone_number: Yup.string()
        //.matches(/^\d{10}$/, "Phone number must be exactly 10 digits")
        .required("Phone number is required"),

      companyName: Yup.string().required("Company name is required"),
      socialMediaLinks: Yup.array().of(
        Yup.object({
          socialMedia: Yup.string().required("Social media link is required"),
          followers: Yup.number()
            .typeError("Must be a number")
            .required("Follower count is required"),
        })
      ),
      experience: Yup.string().required("Experience is required"),
      topic: Yup.string().required("Topic is required"),
      reason: Yup.string().required("Reason is required"),
    }),
    onSubmit: async (values) => {
      console.log("Form values:", values);

        const toastId = toast.loading("Submitting your registration..."); // Create a loading toast with an ID
        const first_name = values.full_name.split(' ')[0];
        const last_name = values.full_name.split(' ')[1];
        console.log({first_name, last_name})
        try {
            const response = await api.post('/forms/website/beta', {
                first_name,
                last_name,
                phone_number: values.phone_number,
                email_address: values.email_address,
                company_name: values.companyName,
                social_media_links: formatSocialMedia(values.socialMediaLinks),
                experience: values.experience,
                topic: values.topic,
                reason: values.reason,
                source: 'creator'
            });
    
            if (response.success) {
              toast.update(toastId, {
                render: <ToastContent header={modalContent.header} body={"Success...."} />,
                type: "success",
                isLoading: false,
                autoClose: 5000
              });
              setShowModal(true);
            } else {
                const errorMessage = response.data?.message || "Something went wrong.";
                toast.update(toastId, {
                    render: <ToastContent header="Error!" body={errorMessage} />,
                    type: "error",
                    isLoading: false,
                    autoClose: 5000
                });
            }
        } catch (error) {
            const errorMessage = error.response?.data?.message || "An error occurred during registration.";
            toast.update(toastId, {
                render: <ToastContent header="Error!" body={errorMessage} />,
                type: "error",
                isLoading: false,
                autoClose: 5000
            });
        }


      
    },
  });

  return (
    <>
      <section className="headerApply">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="headerApplyInner">
                <a href="/rentacademy">
                  <img src="/img/r-logo-new.svg" alt="Rentid Logo" className="img-fluid" />
                </a>
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <a href="/rentacademy">Rent Academy</a>
                    </li>
                    <img src="/img/arrow-right-nav.svg" alt="breadcrumb arrow" />
                    <li className="breadcrumb-item active" aria-current="page">
                      Open Call for Creators
                    </li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="applyAcdemyMain">
        <div className="container">
          <div className="academyFormOuter">
            <div className="academyFormHeading">
              <Link to="/rentacademy">
                <img src="/img/back.svg" className="img-fluid" alt="Back" />
              </Link>
              <h1>Apply Now to Be Featured</h1>
            </div>

            <div className="row justify-content-center">
              <div className="col-lg-12 col-md-12">
                <div className="academyForm">
                  <form onSubmit={formik.handleSubmit}>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="mb-3">
                          <label className="form-label">
                            Full Name <span className="required">*</span>
                          </label>
                          <input
                            name="full_name"
                            type="text"
                            placeholder="Enter your full name"
                            className="form-control"
                            {...formik.getFieldProps("full_name")}
                          />
                          {formik.touched.first_name && formik.errors.full_name && (
                            <div className="text-danger">{formik.errors.full_name}</div>
                          )}
                        </div>
                      </div>

                      <div className="col-md-12">
                        <div className="mb-3">
                          <label className="form-label">
                            Email Address <span className="required">*</span>
                          </label>
                          <input
                            name="email_address"
                            type="email"
                            placeholder="Enter your email address"
                            className="form-control"
                            {...formik.getFieldProps("email_address")}
                          />
                          {formik.touched.email_address && formik.errors.email_address && (
                            <div className="text-danger">{formik.errors.email_address}</div>
                          )}
                        </div>
                      </div>


                      <div className="col-md-12">
                        <div className="mb-3">
                          <label htmlFor="phone_number" className="form-label">Phone Number <span className="required">*</span>
                          </label>
                          <div className="row border align-items-center countryflag m-0">
                            <div className="flagLeft countrycode">
                              <img src="/img/us.svg" className="img-fluid me-2" alt="Country Flag" />
                              <span>+1</span>
                            </div>
                            <div className="flagRight">
                              <input name="phone_number" id="phone_number" placeholder="XXX-XXX-XXX" formatcharacters="[object Object]" className="form-control"
                                {...formik.getFieldProps("phone_number")}
                              />
                            </div>
                          </div>
                          {formik.touched.phone_number && formik.errors.phone_number && (
                            <div className="text-danger">{formik.errors.phone_number}</div>
                          )}
                        </div>
                      </div>

                      <div className="col-md-12">
                        <div className="mb-3">
                          <label className="form-label">
                            Company/Organization Name <span className="required">*</span>
                          </label>
                          <input
                            name="companyName"
                            type="text"
                            placeholder="Enter your company or organization name"
                            className="form-control"
                            {...formik.getFieldProps("companyName")}
                          />
                          {formik.touched.companyName && formik.errors.companyName && (
                            <div className="text-danger">{formik.errors.companyName}</div>
                          )}
                        </div>
                      </div>

                      <div className="col-md-12">
                        <div className="mb-3">

                          <FormikProvider value={formik}>
                            <FieldArray
                              name="socialMediaLinks"
                              render={(arrayHelpers) => (
                                <div>
                                  {formik.values.socialMediaLinks.map((link, index) => (
                                    <div key={index} className="socialMediaForm">
                                      <div className="socialMediaFormLeft">
                                        <label className="form-label">
                                          Social Media Channel
                                          <img
                                            src="/img/tooltip_icon.svg"
                                            width="20px"
                                            height="20px"
                                            className="tooltip_1"
                                            alt="Tooltip"
                                          />
                                          <span className="required">*</span>
                                        </label>
                                        <input
                                          type="text"
                                          placeholder="Social media link"
                                          className="form-control"
                                          {...formik.getFieldProps(`socialMediaLinks.${index}.socialMedia`)}
                                        />
                                        {formik.touched.socialMediaLinks?.[index]?.socialMedia &&
                                          formik.errors.socialMediaLinks?.[index]?.socialMedia && (
                                            <div className="text-danger">
                                              {formik.errors.socialMediaLinks[index].socialMedia}
                                            </div>
                                          )}
                                      </div>

                                      <div className="socialMediaFormRight">
                                        <label className="form-label labelFollwer">
                                          Follower Counts
                                        </label>
                                        <input
                                          type="text"
                                          placeholder="(e.g. 2000)"
                                          className="form-control"
                                          {...formik.getFieldProps(`socialMediaLinks.${index}.followers`)}
                                        />
                                        {formik.touched.socialMediaLinks?.[index]?.followers &&
                                          formik.errors.socialMediaLinks?.[index]?.followers && (
                                            <div className="text-danger">
                                              {formik.errors.socialMediaLinks[index].followers}
                                            </div>
                                          )}
                                      </div>

                                     
                                        <div className="socialMediaFormIcon">
                                          <Link
                                            onClick={(e) => {
                                              e.preventDefault();
                                              arrayHelpers.remove(index); // Remove row
                                            }}
                                            
                                          >
                                            <img src="/img/delete_icon.svg" className="img-fluid" alt="Delete" />

                                          </Link>

                                        </div>
                                    
                                    </div>
                                  ))}

                                  <div className="col-md-12">
                                    <div className="addNewBtn">
                                      <Link type="button" className="btn btnTransparent_21" onClick={() => arrayHelpers.push({ socialMedia: "", followers: "" })}>
                                        <img width="24px" height="24px" src="/img/rentacademy/plus.svg" alt="icon" /> Add New Row
                                      </Link>
                                    </div>
                                  </div>
                                </div>
                              )}
                            />
                          </FormikProvider>
                        </div>
                      </div>



                      <div className="col-md-12">
                        <div className="mb-3">
                          <label className="form-label">Experience or Expertise *</label>
                          <textarea
                            className="form-control"
                            rows="3"
                            placeholder="Briefly describe your experience in the rental industry or related fields"
                            {...formik.getFieldProps("experience")}
                          />
                          {formik.touched.experience && formik.errors.experience && (
                            <div className="text-danger">{formik.errors.experience}</div>
                          )}
                        </div>
                      </div>

                      <div className="col-md-12">
                        <div className="mb-3">
                          <label className="form-label">Proposed Topic *</label>
                          <textarea
                            className="form-control"
                            rows="3"
                            placeholder="What would you like to discuss or contribute to the podcast?"
                            {...formik.getFieldProps("topic")}
                          />
                          {formik.touched.topic && formik.errors.topic && (
                            <div className="text-danger">{formik.errors.topic}</div>
                          )}
                        </div>
                      </div>

                      <div className="col-md-12">
                        <div className="mb-3">
                          <label className="form-label">Why Join the Podcast? *</label>
                          <textarea
                            className="form-control"
                            rows="3"
                            placeholder="Tell us why you’d like to be featured and how you can add value to the conversation"
                            {...formik.getFieldProps("reason")}
                          />
                          {formik.touched.reason && formik.errors.reason && (
                            <div className="text-danger">{formik.errors.reason}</div>
                          )}
                        </div>
                      </div>


                    </div>
                    <div className="applyBottom">
                      <div className="container">
                        <div className="row">
                          <div className="col-4">
                            <a className="btn exitBtn" href="/rentacademy" >Cancel</a>
                            {/* <button type="button" className="btn exitBtn">Cancel</button> */}
                          </div>
                          <div className="col-8 btn-continue text-end d-flex gap-2 align-items-center justify-content-end">
                            <div className="footer-btn-sec">
                              <button type="submit" className="btn btnBlue">Submit Form</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                  {/* END academyForm */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Modal */}
      <Model
        prop={{
          show: showModal,
          setShow: setShowModal,
          content: modalContent,
        }}
      />

    </>
  );
};

export default ApplyAcademy;
